import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyMaintenanceMode = lazy(() => import('./svg-components/maintenance-mode'));

const MaintenanceMode = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyMaintenanceMode {...rest} />
  </Suspense>
);

export default MaintenanceMode;
